import { ORDER_STATUS } from "./order-management";

export const TABLES = (t) => [
  {
    id: 0,
    label: t("detailedOredersReport"),
    link: "/dashboard/detailed-orders-report",
  },
  {
    id: 1,
    label: t("actualDataReport"),
    link: "/dashboard/actual-data-report",
  },
  {
    id: 2,
    label: t("deliveryPerformanceReport"),
    link: "/dashboard/delivery-performance-report",
  },
  {
    id: 3,
    label: t("cancellationAndReturnReport"),
    link: "/dashboard/cancellation-and-return-report",
  },
  {
    id: 4,
    label: t("timePerformanceReport"),
    link: "/dashboard/time-performance-report",
  },
  {
    id: 5,
    label: t("invoiceAndPaymentReport"),
    link: "/dashboard/invoice-and-payment-report",
  },
];

export const REPORTS_EXPORT_TYPE = (t) => [
  {
    id: 0,
    label: t("PDF"),
    value: "PDF",
  },
  {
    id: 1,
    label: t("Excel"),
    value: "xlsx",
  },
  {
    id: 2,
    label: t("CSV"),
    value: "CSV",
  },
];

export const DETAILED_COLUMNS_NAMES = (t, isReversed, viewMode) => {
  let columns = [];
  if (viewMode === "summary") {
    columns = [
      {
        id: 0,
        key: "orderId",
        name: t("orderId"),
      },
      {
        currency: true,
        id: 4,
        key: "deliveryFees",
        name: t("deliveryFees"),
      },
      {
        currency: true,
        id: 5,
        key: "orderAmount",
        name: t("orderFees"),
      },
      {
        id: 10,
        key: "status",
        name: t("status"),
      },
    ];
  } else {
    columns = [
      {
        id: 0,
        key: "orderId",
        name: t("orderId"),
      },
      {
        id: 1,
        key: "date",
        name: t("date"),
      },
      {
        id: 2,
        key: "customer",
        name: t("customer"),
      },
      {
        id: 3,
        key: "driverName",
        name: t("driverName"),
      },
      {
        currency: true,
        id: 4,
        key: "deliveryFees",
        name: t("deliveryFees"),
      },
      {
        currency: true,
        id: 5,
        key: "orderAmount",
        name: t("orderFees"),
      },
      {
        id: 6,
        key: "pickupLocation",
        name: t("pickupLocation"),
      },
      {
        id: 7,
        key: "pickupTime",
        name: t("pickUpColumnName"),
      },
      {
        id: 8,
        key: "deliveryLocation",
        name: t("deliveryLocation"),
      },
      {
        id: 9,
        key: "deliveryTime",
        name: t("dropOffColumnName"),
      },
      {
        id: 10,
        key: "status",
        name: t("status"),
      },
    ];
  }

  return isReversed ? columns.reverse() : columns;
};

export const ACTUAL_COLUMNS_NAMES = (t, isReversed, viewMode) => {
  let columns = [];
  if (viewMode === "summary") {
    columns = [
      {
        id: 0,
        key: "orderId",
        name: t("orderId"),
      },
      {
        id: 3,
        key: "actualPickup",
        name: t("actualPickup"),
      },
      {
        id: 5,
        key: "actualDelivery",
        name: t("actualDelivery"),
      },
    ];
  } else {
    columns = [
      {
        id: 0,
        key: "orderId",
        name: t("orderId"),
      },
      {
        id: 1,
        key: "customer",
        name: t("customer"),
      },
      {
        id: 2,
        key: "scheduledPickup",
        name: t("scheduledPickup"),
      },
      {
        id: 3,
        key: "actualPickup",
        name: t("actualPickup"),
      },
      {
        id: 4,
        key: "sheduledDelivery",
        name: t("sheduledDelivery"),
      },
      {
        id: 5,
        key: "actualDelivery",
        name: t("actualDelivery"),
      },
    ];
  }

  return isReversed ? columns.reverse() : columns;
};

export const DELIVERY_PERFORMANCE_COLUMNS_NAMES = (t, isReversed) => {
  const columns = [
    {
      id: 1,
      key: "orderId",
      name: t("orderId"),
    },
    {
      id: 2,
      key: "schedualedDate",
      name: t("schedualedDate"),
    },
    {
      id: 3,
      key: "deliveredDate",
      name: t("deliveredDate"),
    },
    {
      id: 4,
      key: "status",
      name: t("status"),
    },
  ];

  return isReversed ? columns.reverse() : columns;
};

export const TIME_PERFORMANCE_COLUMNS_NAMES = (t, isReversed) => {
  const columns = [
    {
      id: 0,
      key: "orderId",
      name: t("orderId"),
    },
    {
      id: 1,
      key: "driverName",
      name: t("driverName"),
    },
    {
      id: 2,
      key: "schedualedDeliveryTime",
      name: t("schedualedDeliveryTime"),
    },
    {
      id: 3,
      key: "actualDeliveryTime",
      name: t("actualDeliveryTime"),
    },
    {
      id: 4,
      key: "earlyOrLateMinutes",
      name: t("earlyOrLateMinutes"),
    },
  ];

  return isReversed ? columns.reverse() : columns;
};

export const INVOICE_AND_PAYMENT_COLUMNS_NAMES = (t, isReversed) => {
  const columns = [
    {
      id: 0,
      key: "orderId",
      name: t("orderId"),
    },
    {
      id: 1,
      key: "orderFees",
      name: t("orderFees"),
    },
    {
      currency: true,
      id: 2,
      key: "deliveryFees",
      name: t("deliveryFees"),
    },
    {
      currency: true,
      id: 3,
      key: "totalAmountBilled",
      name: t("totalAmountBilled"),
    },
    {
      id: 4,
      key: "paymentStatus",
      name: t("paymentStatus"),
    },
  ];

  return isReversed ? columns.reverse() : columns;
};

export const CANCELLATION_COLUMNS_NAMES = (t, isReversed) => {
  const columns = [
    {
      id: 0,
      key: "orderId",
      name: t("orderId"),
    },
    {
      id: 1,
      key: "cancellationOrReturnDate",
      name: t("cancellationOrReturnDate"),
    },
  ];

  return isReversed ? columns.reverse() : columns;
};

export const viewOptions = (t) => [
  {
    label: t("detailed"),
    value: "detailed",
  },
  {
    label: t("summary"),
    value: "summary",
  },
];

export const timeOptions = (t) => [
  {
    label: t("Am"),
    value: "Am",
  },
  {
    label: t("Pm"),
    value: "Pm",
  },
];

export const ALLOWED_STATUSES = {
  DetailedOrdersReport: [
    ORDER_STATUS.AWAITING_SELECTION,
    ORDER_STATUS.PENDING_PICKUP,
    ORDER_STATUS.PICKUP_STARTED,
    ORDER_STATUS.ARRIVED_AT_PICKUP,
    ORDER_STATUS.ORDER_COLLECTED,
    ORDER_STATUS.ORDER_OUT_FOR_DELIVERY,
    ORDER_STATUS.ARRIVED_AT_DROPOFF,
    ORDER_STATUS.DELIVERED,
    ORDER_STATUS.CANCELLED,
    ORDER_STATUS.REJECTED,
    ORDER_STATUS.ON_HOLD,
    ORDER_STATUS.RESCHEDULED,
    ORDER_STATUS.REQUEST_DRIVER_CHANGE,
    ORDER_STATUS.DRIVER_CHANGE_APPROVED,
  ],
  deliveryPerformance: [
    ORDER_STATUS.DELIVERED,
    ORDER_STATUS.CANCELLED,
    ORDER_STATUS.REJECTED,
    ORDER_STATUS.FAILED,
  ],
  invoiceAndPayment: [
    ORDER_STATUS.AWAITING_SELECTION,
    ORDER_STATUS.PENDING_PICKUP,
    ORDER_STATUS.PICKUP_STARTED,
    ORDER_STATUS.ARRIVED_AT_PICKUP,
    ORDER_STATUS.ORDER_COLLECTED,
    ORDER_STATUS.ORDER_OUT_FOR_DELIVERY,
    ORDER_STATUS.ARRIVED_AT_DROPOFF,
    ORDER_STATUS.DELIVERED,
    ORDER_STATUS.ON_HOLD,
    ORDER_STATUS.RESCHEDULED,
    ORDER_STATUS.REQUEST_DRIVER_CHANGE,
    ORDER_STATUS.DRIVER_CHANGE_APPROVED,
  ],
};

export const ViewTypeEnum = {
  DETAILED: 2,
  SUMMARY: 1,
};
